module.exports = __webpack_public_path__ + "slap.cdc0fee7.png";